module.exports = __webpack_public_path__ + "img/1520232017.99ec81f9.jpg";